// src/utils/patientStatus.ts
// TODO: Move this file to app/modules/user/helper/patientHelpers.ts for better organization
// This contains patient-related utility functions that logically belong with other helpers

export enum PatientStatus {
  Inactive = 0,
  Active = 1,
  // room for other states later, e.g. Suspended = 2
}

/**
 * Returns true when the patient is ACTIVE.
 * Accepts either a Patient object or a raw status code.
 */
export function isPatientActive(
  patientOrStatus: {status?: number} | number | undefined | null
): boolean {
  const status = typeof patientOrStatus === 'number' ? patientOrStatus : patientOrStatus?.status

  return status === PatientStatus.Active
}
